module.exports = __webpack_public_path__ + "c2ff8e54bd2a19ab75c2ddd0e4ecdbdc.pdf";